type  RecommendedServing = {label: string, index: number};

const createSVGElement = (tag: string, attrs: Record<string, string>) => {
  const element = document.createElementNS('http://www.w3.org/2000/svg', tag);
  Object.entries(attrs).forEach(([key, val]) => element.setAttribute(key, val));
  return element;
};

export const parseRecommendedServings = (rawValues?: Array<string>): Array<RecommendedServing> => {
  const items: Array<RecommendedServing> = [];
  try {
    rawValues?.forEach((item) => {
      const [label, index] = item.split(',');
      items.push({label: label.trim(), index: parseInt(index.trim())});
    });
  } catch {
    //ignore
  }

  return items;
};

const insertElement = (recommendedServing: RecommendedServing)=>{
  try {
    const servingsContainer = document.querySelector<HTMLDivElement>('.servings-selector');
    const key = `.${recommendedServing.label.replace(' ','-')}-${recommendedServing.index}`
    const existingFeatureServing = document.querySelector<HTMLDivElement>(key);

    if (!servingsContainer || existingFeatureServing) return;

    const buttons = servingsContainer.querySelectorAll('button');
    const lastButton = buttons[recommendedServing.index];
    if (!lastButton) return;

    const featureServingContainer = document.createElement('div');
    featureServingContainer.className = `__feature-serving ${recommendedServing.label.replace(' ','-')}-${recommendedServing.index}`;


    const ribbon = createSVGElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '87',
      height: '26',
      viewBox: '0 0 87 26',
      fill: 'none',
    });

    const path = createSVGElement('path', {
      d: 'M0 0L86.5 0L79.9504 13L86.5 26H0L6.54962 13L0 0Z',
      fill: '#F4E04D',
    });

    const text = document.createElement('span');
    text.textContent = recommendedServing.label;

    ribbon.appendChild(path);
    featureServingContainer.append(text, ribbon);
    lastButton.appendChild(featureServingContainer);
  }catch {
    //ignore
  }
}

export const applyFeatureRibbon = (values?: Array<string>) => {
  if (!values || values.length === 0) {
    return;
  }

  const recommendedServings: RecommendedServing[] = parseRecommendedServings(values);

  if(recommendedServings.length === 0) {
    return;
  }

  recommendedServings.forEach((serving) => {
    insertElement(serving);
  });
};

